import CryptoJS from 'crypto-js';
import { Cookies } from 'react-cookie';
const secretKey = process.env.REACT_APP_ENCRIPT_KEY;

const cookies = new Cookies();
const virtualPath = '';

export const encryptData = (data) => {
    try {
        const dataString = typeof data === 'object' ? JSON.stringify(data) : data;
        const encrypted = CryptoJS.AES.encrypt(dataString, secretKey).toString();
        return encrypted;
    } catch (error) {
        //console.error('Error encrypting data:', error);
        return null;
    }
};

export const decryptData = (encryptedData) => {
    try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        if (!decryptedData) {
            throw new Error('Decryption failed or data is empty');
        }
        try {
            return JSON.parse(decryptedData);
        } catch (jsonError) {
            return decryptedData;
        }
    } catch (error) {
        //console.error('Error decrypting data:', error);
        return null;
    }
};


//export const SetSession = (type, key, value) => {
//    let tempKey = (virtualPath).replace("/", "").toLowerCase() + "_" + key;
//    let encryptedValue = encryptData(value);

//    if (type.toLowerCase() === 'localstorage') {
//        window.localStorage.setItem(tempKey, encryptedValue);
//    } else if (type.toLowerCase() === 'cookies') {
//        cookies.set(tempKey, encryptedValue, {
//            path: '/',
//            expires: new Date(new Date().getTime() + 60 * 60 * 1000),
//            secure: true,
//            sameSite: 'None'
//        });
//    } else if (type.toLowerCase() === 'sessionstorage') {
//        sessionStorage.setItem(tempKey, encryptedValue);
//    } else {
//        console.warn('Invalid storage type provided.');
//    }
//}

export const SetSession = (type, key, value) => {
    const allowedOrigins = [
        'https://localhost:44420',
        'https://localhost:44430',
        'https://demo.sagarinfotech.com',
        'https://dealer.cppwebservices.in',
        'https://dealeruat.cppwebservices.in',
        'https://merchants.bajajfinserv.in',
        'https://uatmerchant.bajajfinserv.in',
        'https://uatbusinessloan.bajajfinserv.in',
        'https://businessloan.bajajfinserv.in',
    ];

    let tempKey = (virtualPath).replace("/", "").toLowerCase() + "_" + key;
    let encryptedValue = encryptData(value);

    const currentOrigin = window.location.origin;
    let TopOrigin = null;
    try {
        TopOrigin = window.top.location.origin;
    } catch (error) {
        //console.warn('Cross-origin access blocked:', error);
    }


    if (type.toLowerCase() === 'cookies') {
        if (allowedOrigins.includes(currentOrigin) || allowedOrigins.includes(TopOrigin)) {
        cookies.set(tempKey, encryptedValue, {
            path: '/',
            expires: new Date(new Date().getTime() + (60 * 60 * 1000 * 8)),
            secure: true,
            sameSite: 'None'
        });
        } else {
        //console.warn('This origin is not allowed to set cookies');
        }
    } else if (type.toLowerCase() === 'localstorage') {
        window.localStorage.setItem(tempKey, encryptedValue);
    } else if (type.toLowerCase() === 'sessionstorage') {
        sessionStorage.setItem(tempKey, encryptedValue);
    } else {
        //console.warn('Invalid storage type provided.');
    }
};


export const GetSession = (type, key) => {
    let tempKey = (virtualPath).replace("/", "").toLowerCase() + "_" + key;
    let data;

    if (type.toLowerCase() === 'localstorage') {
        data = window.localStorage.getItem(tempKey);
    } else if (type.toLowerCase() === 'cookies') {
        data = cookies.get(tempKey);
    } else if (type.toLowerCase() === 'sessionstorage') {
        data = sessionStorage.getItem(tempKey);
    } else {
        //console.warn('Invalid storage type provided.');
        return null;
    }

    return data ? decryptData(data) : null;
}

export const RemoveSession = (type, key) => {
    let tempKey = (virtualPath).replace("/", "").toLowerCase() + "_" + key;

    if (type.toLowerCase() === 'localstorage') {
        localStorage.removeItem(tempKey);
    } else if (type.toLowerCase() === 'cookies') {
        cookies.remove(tempKey, { path: '/' });
    } else if (type.toLowerCase() === 'sessionstorage') {
        sessionStorage.removeItem(tempKey);
    } else {
        //console.warn('Invalid storage type provided.');
    }
}